import { render, staticRenderFns } from "./EditSuccess.vue?vue&type=template&id=b0304166&scoped=true&"
import script from "./EditSuccess.vue?vue&type=script&lang=js&"
export * from "./EditSuccess.vue?vue&type=script&lang=js&"
import style0 from "./EditSuccess.vue?vue&type=style&index=0&id=b0304166&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0304166",
  null
  
)

export default component.exports